import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useActiveLocale } from './hooks';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function LocaleLayout() {
  const locale = useActiveLocale();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Change i18n language when locale changes
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    // Save locale to localStorage
    localStorage.setItem('locale', locale);
    // Set document language attribute
    document.documentElement.lang = locale;
  }, [locale, i18n]);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Navigation />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default LocaleLayout;
